import { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import PlayButton from "../../ui/PlayButton";

const PositionSymbol = styled.div<{ active?: boolean }>`
  background-color: #eee;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  margin: 5px;
  align-items: center;
  ${(p: any) =>
    p.active &&
    css`
      background-color: #cadee9;
      color: white;
    `}
`;

const SymbolRow = styled.div`
  position: absolute;
  bottom: 5%;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
`;

const MemoImage = styled.img`
  position: absolute;
  display: flex;
  justify-content: center;
  top: 15%;
  transition: opacity 0.5s;
  `;

const buildPositionNumbers = (amountOfMemoSymbols: number) => {
  const numbers = new Array(amountOfMemoSymbols);
  for (let i = 0; i < numbers.length; i++) {
    numbers[i] = i + 1;
  }
  return numbers;
};

const MemorizeScreen = ({ memorizeSymbols, amountOfMemoSymbols, setShowMemo, setShowBetween }: any) => {
  const numbers = buildPositionNumbers(amountOfMemoSymbols);
  const [currentNumber, setCurrentNumber] = useState(1);
  const [currentImage, setCurrentImage] = useState(0);
  const imageRef: any = useRef(null);

  const handleNextImage = () => {
    setCurrentImage(currentNumber);
    setCurrentNumber(currentNumber + 1);
  };

  useEffect(() => {
    let timer1: any;
    let timer2: any;
    if (currentNumber <= amountOfMemoSymbols) {
        imageRef.current.style.opacity = "1";
        timer1 = setTimeout(() => handleNextImage(), 2000);
        timer2 = setTimeout(() => (imageRef.current.style.opacity = "0"), 1400);
    } else {
      setShowMemo(false);
      setShowBetween(true);
    }
    return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);

    }
  }, [currentNumber]);

  return (
    <>
      <MemoImage ref={imageRef} src={memorizeSymbols[currentImage]} />
      <SymbolRow>
        {numbers.map((n: any) => (
          <PositionSymbol key={n} active={n === currentNumber}>{n}</PositionSymbol>
        ))}
      </SymbolRow>
    </>
  );
};

export default MemorizeScreen;
